export const VIDEO_URL =
  'https://ledasales-statics.s3.amazonaws.com/videos/COMO+ESCANEAR+AMBAS.mp4';
export const POSTER_URL = '/images/videoCovers/connect.png';

// The QR code is delivered asynchronously over the socket after a QR request.
// If it has not arrived within this window the request has silently failed
// (e.g. the provider account was deleted — INT-937); the modal shows a retry
// state instead of spinning forever.
export const QR_TIMEOUT_MS = 40_000;
